module.exports = __webpack_public_path__ + "assets/img/00013.5086f73b.png";